import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { LoginComponent } from '../components/login.component';
import { LoginService } from '../services/login.service';
import { AnalyticsCoreURLService } from '../../../reporting/analytics-core/services/analytics-core.url.service';

@Component({
	selector: 'ssologin',
	templateUrl: 'ssologin.component.html',
	styleUrls: ['../styles/login.component.css']
})
export class SsoLoginComponent extends LoginComponent {
	constructor(
		private ssoLoginService: LoginService,
		private ssoRouter: Router,
		private ssoStorageSessionService: StorageSessionService,
		private ssoAnalyticsCoreURLService: AnalyticsCoreURLService
	) {
		super(ssoLoginService, ssoRouter, ssoStorageSessionService, ssoAnalyticsCoreURLService);
	}

	validateApiLoginUserid() {
		if (this.username === '') {
			this.showLoginLoader = false;
			this.errorMessage = 'Please fill in your details.';
		} else {
			this.showLoginLoader = true;
			var hostnameurl = this.ssoLoginService.getHostname();
			var queryParamsObj = this.ssoStorageSessionService.getQueryParamsObj();
			var relayState = window.location.protocol + '//' + hostnameurl;
			var relayStateProduct = this.ssoStorageSessionService.URLproductRoute;
			this.ssoLoginService
				.validateApiLoginUserid({
					username: this.username,
					pwd: this.password,
					hostname: hostnameurl,
					relayState: relayState,
					queryParams: queryParamsObj,
					relayStateProduct: relayStateProduct
				})
				.subscribe((response: any) => {
					if (response.success) {
						if (response.is_sso_domain) {
							window.location.href = response.redirect_url;
						} else {
							this.showSSOUserEmailSection = false;
							this.showLoginLoader = false;
							this.errorMessage = '';
						}
					} else {
						this.errorMessage = response.message;
						this.showSSOUserEmailSection = true;
						this.showLoginLoader = false;
						this.showLoginLoader = false;
					}
				});
		}
	}
}
